import { Destroyer, trimUrl } from '@apps/tools';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { takeUntil, filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class ThemeService extends Destroyer {
    constructor(router) {
        super();
        this.router = router;
        this.productSubject = new BehaviorSubject('prad');
        this.product$ = this.productSubject.asObservable();
        this.init();
    }
    get currentProduct() {
        return this.productSubject.getValue();
    }
    init() {
        this.router.events
            .pipe(takeUntil(this.destroy$), filter(e => e instanceof NavigationEnd), map((e) => {
            const path = trimUrl(e.url).split('/');
            let type = path && path[1];
            if (type === 'kalkulator' || (path && path[1] === 'artykuly')) {
                type = path[2];
            }
            if (['prad', 'gaz', 'fotowoltaika'].includes(type)) {
                return type;
            }
            return 'prad';
        }))
            .subscribe((type) => {
            this.productSubject.next(type);
        });
    }
}
ThemeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeService_Factory() { return new ThemeService(i0.ɵɵinject(i1.Router)); }, token: ThemeService, providedIn: "root" });
